import FluxoDefault from "./FluxoDefault";
import { useCallback, useState } from "react";

const FluxoDefaultConnected = () => {
  const [step, setStep] = useState(0);

  const handleGoTo0 = useCallback(() => {
    setStep(0);
  }, [setStep]);
  const handleGoTo1 = useCallback(() => {
    setStep(1);
  }, [setStep]);
  const handleGoTo2 = useCallback(() => {
    setStep(2);
  }, [setStep]);
  const handleGoTo3 = useCallback(() => {
    setStep(3);
  }, [setStep]);

  const events = [handleGoTo1, handleGoTo2, handleGoTo3];

  return (
    <FluxoDefault
      step={step}
      setStep={setStep}
      events={events}
      handleGoTo0={handleGoTo0}
      handleGoTo1={handleGoTo1}
      handleGoTo2={handleGoTo2}
      handleGoTo3={handleGoTo3}
    />
  );
};

export default FluxoDefaultConnected;
